import { ReferenceBadge } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';
import { COLOR_TOKEN } from '../../../helpers/color-tokens';
import { AlertType } from '../alerts-type';

export const ContainerEntregaIdeal = styled.div<{
	alertType: AlertType;
	alertPosition: number;
	numberOfAlerts: number;
	vehicleInterior: string;
	windowWidth: number;
}>`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	cursor: pointer;
	flex-grow: 1;
	width: 100%;
	border-radius: 16px;
	overflow: hidden;
	box-shadow:
		0px 3px 15px rgba(0, 14, 38, 0.1),
		0px 2px 4px rgba(0, 14, 38, 0.2);

	${(props: { alertType: AlertType; vehicleInterior: any }) =>
		props.alertType === AlertType.EntregaIdeal &&
		`
			background: linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.1) 100%);

			/* Capa con ambas imágenes */
			&::before {
				content: '';
				position: absolute;
				inset: 0;
				z-index: 0;

				/* OJO: primero la imagen de fondo, luego la del interior (para que la interior quede arriba) */
				background-image:
					url(${props.vehicleInterior || 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/entrega_ideal-background.jpg'}),
					url('https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/entrega_ideal-background.jpg');

				background-position: center;
				background-repeat: no-repeat;
				background-size: cover;
				background-blend-mode: normal;

				/* Pequeña transparencia para que ambas se vean */
				opacity: 0.95;
			}
		`}

	/* Asegura que el contenido se vea sobre las imágenes */
	> * {
		position: relative;
		z-index: 1;
	}

	${(props: { alertType: AlertType; numberOfAlerts: number; windowWidth: number }) => {
		if (props.alertType === AlertType.EntregaIdeal && props.numberOfAlerts === 1) {
			if (props.windowWidth < 560) {
				return `aspect-ratio: 4 / 3; height: auto;`;
			}

			if (props.windowWidth >= 560 && props.windowWidth < 960) {
				return `aspect-ratio: 4 / 3; height: auto;`;
			}

			if (props.windowWidth >= 960 && props.windowWidth < 1600) {
				return `aspect-ratio: 2 / 1; height: auto;`;
			}

			if (props.windowWidth >= 1600) {
				return `aspect-ratio: 5 / 2; height: auto;`;
			}
		}
		return '';
	}}
`;

export const CardContainer = styled.div<{
	alertType: AlertType;
	alertPosition: number;
	numberOfAlerts: number;
	vehicleInterior: string;
	windowWidth: number;
}>`
	position: relative;
	display: flex;
	cursor: pointer;
	height: 100%;
	width: ${(props: { numberOfAlerts: number; alertPosition: number; windowWidth: number }) => {
		const { numberOfAlerts, alertPosition, windowWidth } = props;

		if (windowWidth < 960) {
			return '100% !important';
		}

		if ((numberOfAlerts > 2 && alertPosition === 0) || (numberOfAlerts < 2 && alertPosition === 0)) {
			return '90.8vw';
		}
		if ((numberOfAlerts === 2 && alertPosition === 0) || (numberOfAlerts > 2 && alertPosition === 1)) {
			return '49vw';
		}
		if ((numberOfAlerts === 2 && alertPosition === 1) || (numberOfAlerts > 2 && alertPosition === 2)) {
			return '37vw';
		}

		return '100%';
	}};

	border-radius: 16px;
	text-align: left;
	background: ${COLOR_TOKEN.background.tertiary};
	box-shadow: none;

	flex-direction: ${(props: { windowWidth: number; numberOfAlerts: number; alertPosition: number }) =>
		(props.windowWidth >= 960 && props.numberOfAlerts > 2 && props.alertPosition === 0) ||
		(props.windowWidth >= 960 && props.numberOfAlerts === 1)
			? 'row'
			: 'column'};
`;

export const ImageWrapper = styled.div`
	width: 58vw;
	min-width: 58vw;
	max-width: 58vw;
	border-radius: 16px 0 0 16px;
	overflow: hidden;
	flex-shrink: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const TextWrapper = styled.div`
	padding: var(--size-dynamic0100);
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	height: 100%;
`;

export const CTAContainer = styled.div<{
	numberOfAlerts: number;
	alertPosition: number;
}>`
	padding-bottom: var(--size-dynamic0100);
	padding-right: var(--size-dynamic0100);
`;

export const CTAStyled = styled.div<{ alertType: AlertType }>`
	& > button {
		height: 40px;
		width: 40px;
		min-height: 40px;
		min-width: 40px;

		@media (min-width: 560px) and (max-width: 959px) {
			height: 48px;
			width: 48px;
			min-height: 48px;
			min-width: 48px;
		}

		@media (min-width: 960px) {
			height: 56px;
			width: 56px;
			min-height: 56px;
			min-width: 56px;
		}

		& svg {
			height: 20px;
			width: 20px;

			@media (min-width: 560px) and (max-width: 959px) {
				height: 24px;
				width: 24px;
			}

			@media (min-width: 960px) {
				height: 28px;
				width: 28px;
			}
		}
	}
`;

export const DescriptionTextContainer = styled.div`
	@media screen and (max-width: 959px) {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
	}
`;

export const StyledReferenceBadge = styled(ReferenceBadge)`
	vertical-align: top;
	&::before {
		content: none;
	}
`;

export const AspectRatioWrapper = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;

	> * {
		flex-grow: 1;
		height: 100% !important;
	}
`;

export const VideoStyled = styled.video`
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 16px;
`;
